function Goals() {
    return(
        <h1>yet to post</h1>
    )
}
export default Goals;